import script from "./PressModeDownloadButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./PressModeDownloadButton.vue?vue&type=script&lang=ts&setup=true"

import "./PressModeDownloadButton.vue?vue&type=style&index=0&id=37db95d9&lang=less"

const __exports__ = script;

export default __exports__